import styled from 'styled-components';

import { SearchIcon } from '../../../icons';
import Input from '../Input';

export const SearchInput = styled(Input).attrs({
  leading: SearchIcon,
  isErrorInitiallyHidden: true,
  elementSize: 'medium',
})``;
